import { fetchUtils } from 'ra-core';
const { APIHUB_URL, TENANT_NAME, ORIGIN_HUB_NAME } = global.APIHUB_CONFIG;
export function getFetchJson(originHubName) {
    if (!originHubName) {
        originHubName = ORIGIN_HUB_NAME;
    }
    return (url, options = {}) => {
        if (!options.headers) {
            options.headers = new Headers({ Accept: 'application/json' });
        }
        options.headers.set('Content-Type', 'application/json; charset=UTF-8');
        options.headers.set('Origin-Hub-Name', originHubName);
        options.credentials = options.credentials || 'include';
        return fetchUtils.fetchJson(url, options);
    };
}
//# sourceMappingURL=fetchUtils.js.map